import styled from 'styled-components';
import FlexBox from '../../components/FlexBox';

export const BannerBox = styled.div`
  width: 100%;
  height: ${({ height }) => `${height}px`};
  background-image: url(${({ bg }) => encodeURI(bg)});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  > .activityTime {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 30px;
    font-weight: 500;
    font-size: 24px;
    line-height: 31px;
    color: #fff;
    text-align: center;
  }
  @media screen and (max-width: 414px) {
    .activityTime {
      font-size: 12px;
      line-height: 100%;
      top: 0;
    }
  }
`;
export const Desc = styled.div`
  background: #fff;
  font-size: 18px;
  line-height: 1.5;
  color: #48515d;
  padding: 40px 20px;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  > strong {
    font-family: ${({ theme }) => theme.fontIBMSemiBold};
  }
  time {
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: #212833;
    display: block;
    margin-bottom: 8px;
    font-family: ${({ theme }) => theme.fontIBMSemiBold};
  }
  @media screen and (max-width: 414px) {
    padding: 20px;
    text-align: left;
    font-size: 14px;
    line-height: 18px;
  }
`;
export const Section = styled(FlexBox)`
  width: 100%;
  padding: ${({ padding }) => padding || '80px 10px'};
  background-color: ${({ bg }) => bg};
  @media screen and (max-width: 414px) {
    padding: 30px 10px;
  }
`;
export const SectionTitle = styled.div`
  font-family: ${({ theme }) => theme.fontIBMLight};
  font-size: 42px;
  color: #212833;
  line-height: 1.35;
  font-weight: normal;
  margin-bottom: 85px;
  text-align: center;
  position: relative;
  :after {
    content: ' ';
    display: inline-block;
    width: 60px;
    height: 5px;
    background: #f0b90b;
    position: absolute;
    left: 50%;
    margin-left: -30px;
    bottom: -20px;
  }

  @media screen and (max-width: 414px) {
    font-size: 24px;
    line-height: 31px;
    margin-bottom: 47px;
  }
`;
export const SectionDesc = styled.div`
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-size: 16px;
  line-height: 22px;
  color: #48515d;
  margin-bottom: 30px;
  a,
  a:visited {
    text-decoration: underline;
  }
  a:hover {
    color: ${({ theme }) => theme.highlight};
  }
  strong {
    font-family: ${({ theme }) => theme.fontIBMBold};
    font-size: 18px;
  }
  @media screen and (max-width: 414px) {
    font-size: 14px;
    line-height: 18px;
  }
`;
export const RewardsBox = styled(FlexBox)`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  @media screen and (max-width: 414px) {
    background: none;
    box-shadow: none;
  }
`;
export const RewardItem = styled(FlexBox)`
  padding: 30px;
  border-right: 1px solid #eaecef;
  background: #ffffff;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  h4 {
    font-size: 26px;
    line-height: 33px;
    margin: 0 0 12px;
    color: #212833;
  }

  p {
    font-size: 16px;
    line-height: 21px;
    color: #848e9c;
    height: 106px;
    margin-bottom: 40px;
  }
  :last-of-type {
    border-right: none;
  }
  @media screen and (max-width: 414px) {
    padding: 20px;
    border-right: none;
    flex: auto;
    margin-bottom: 10px;
    flex-wrap: nowrap;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    justify-content: space-between;
    h4 {
      font-size: 18px;
      line-height: 23px;
      margin: 0;
    }
    p {
      font-size: 14px;
      line-height: 18px;
      height: auto;
      margin: 0;
    }
    img {
      width: 66px;
    }
  }
`;
export const ActivityItems = styled.div`
  font-family: ${({ theme }) => theme.fontIBMRegular};
  h3 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: #48515d;
  }
  ul {
    /* list-style-type: none; */
    margin-left: 20px;
    margin-bottom: 30px;
  }
  li {
    font-size: 14px;
    line-height: 22px;
    color: #848e9c;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
  p.riskTip {
    font-size: 14px;
    line-height: 22px;
    color: #848e9c;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
`;
export const TradeRanks = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  padding: 40px 150px;
  @media screen and (max-width: 414px) {
    padding: 24px 10px 30px;
  }
`;
export const RankTitle = styled(FlexBox)`
  font-family: ${({ theme }) => theme.fontIBMLight};
  font-size: 54px;
  line-height: 70px;
  padding: 0 30px;
  position: relative;
  :after,
  :before {
    content: ' ';
    display: inline-block;
    width: 22px;
    height: 22px;
    background: linear-gradient(315deg, #f0b90b 0.5%, #fbda3c 98.51%);
    transform: rotate(45deg) translateY(-50%);
    position: absolute;
    top: 50%;
  }
  :after {
    right: -18px;
  }
  :before {
    left: -34px;
  }
  @media screen and (max-width: 414px) {
    font-size: 24px;
    line-height: 31px;
    :after,
    :before {
      width: 10px;
      height: 10px;
    }
    :after {
      right: -2px;
    }
    :before {
      left: -9px;
    }
  }
`;
export const UserRankInfo = styled.div`
  width: 100%;
  text-align: center;
  font-size: 16px;
  line-height: 21px;
  color: #212833;
  margin: 30px 0;
  a,
  a:visited {
    color: ${({ theme }) => theme.highlight};
  }
  a:hover {
    text-decoration: underline;
  }
  @media screen and (max-width: 414px) {
    font-weight: 500;
    font-size: 13px;
    line-height: 17px;
    margin: 14px 0 20px;
  }
`;
export const TipBox = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(33, 40, 51, 1);
  line-height: 18px;
  /* max-width: 280px; */
  width: 136px;
  /* height: 72px; */
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  > .share-text {
    /* width: 40px;
    height: 40px; */
    margin-top: 16px;
    text-align: center;
    /* line-height: 40px; */
  }

  > div .share-link {
    display: inline-block;
    /* width: 40px;
    height: 40px; */
    margin: 17px;
    margin-bottom: 9px;
    margin-right: 12px;
    margin-left: 12px;
    text-align: center;
    /* line-height: 40px; */
  }
`;
export const UpdataTime = styled.div`
  text-align: center;
  height: auto;
  overflow: hidden;
`;
export const ShardLinks = styled.div`
  text-align: center;
  float: ${({ isMobile }) => !isMobile && 'right'};
  justify-content: ${({ isMobile }) => isMobile && 'flex-end'};
  height: 24px;
  display: flex;
  align-items: center;
  margin-top: ${({ isMobile }) => (isMobile ? '9px' : '0')};
  margin-bottom: ${({ isMobile }) => (isMobile ? '11px' : '24px')};
  > div {
    width: 99px;
    background-image: url(${require('./images/shard_icon.svg')});
    background-repeat: no-repeat;
    background-position-y: 50%;
    padding-left: 23px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #212833;
    /* margin-left: 9px; */
  }

  > div:hover {
    color: #f0b90b;
    background-image: url(${require('./images/shard_icon_light.svg')});
  }
`;
